// Local translations
export const T = {
  en_GB: {
    previewAlt: "Preview",
    uploadImage: "Upload Image",
    supportedFormats: "Supported formats: PNG (max 500 KB), SVG (max 100 KB)",
    imageUploaded: "Image uploaded",
    previewNote: "Preview shows alignment and relative width",
    width: "Width (%)",
    widthHelp: "Percentage of page width (10-100%)",
    alignment: "Alignment",
    left: "Left",
    center: "Center",
    right: "Right",
    fileTooLarge: "File too large. Max size:",
    validationError: "Please upload an image",
  },
  nb_NO: {
    previewAlt: "Forhåndsvisning",
    uploadImage: "Last opp bilde",
    supportedFormats: "Støttede formater: PNG (maks 500 KB), SVG (maks 100 KB)",
    imageUploaded: "Bilde lastet opp",
    previewNote: "Forhåndsvisning viser justering og relativ bredde",
    width: "Bredde (%)",
    widthHelp: "Prosent av sidebredde (10-100%)",
    alignment: "Justering",
    left: "Venstre",
    center: "Midtstilt",
    right: "Høyre",
    fileTooLarge: "Filen er for stor. Maks størrelse:",
    validationError: "Vennligst last opp et bilde",
  },
} as const;
